import React from "react";
import { useNavigate } from "react-router-dom";
;
import { IconArrowLeft } from "@velaro/velaro-component-lib/";
import IconByName from "@/components/ds/IconByName";

import { PrimaryButton } from "@/components/ds";

export default function HubSpotOverview() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="font-semibold group flex items-center gap-2 justify-between mb-6">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 border-zinc-300 relative mr-4 rounded border p-2 content-center flex items-center justify-center">
            <img src="/img/hubspot-crm.svg" alt="HubSpot" className="w-10 h-10" />
          </div>
          <div>
            <div className="font-semibold text-slate-gray-800 text-lg">HubSpot CRM</div>
            <div className="font-normal text-slate-gray-400 text-sm">
              Connect HubSpot to look up contacts, push transcripts, and sync chat data to your CRM.
            </div>
          </div>
        </div>
        <PrimaryButton
          label="Connect HubSpot"
          onClick={() => navigate("/integrations/hubspot/create")}
          prefixIcon={null}
          className="font-medium"
        />
      </div>

      <div className="flex border-b mb-4">
        <div className="py-2 mr-4 cursor-pointer text-zinc-800 text-sm border-b-2 border-b border-zinc-600 px-3">
          Overview
        </div>
      </div>

      <div className="flex items-start gap-3 rounded-lg border border-[var(--color-primary)] bg-blue-50 dark:bg-blue-950 px-4 py-3 mb-6">
        <div className="mt-0.5 text-[var(--color-primary)] shrink-0">
          <IconByName name="Sparkles" className="w-5 h-5" />
        </div>
        <div>
          <div className="font-semibold text-zinc-800 dark:text-zinc-100 text-sm">
            The most powerful HubSpot chat integration available
          </div>
          <div className="text-xs text-zinc-600 dark:text-zinc-400 mt-0.5">
            29 AI workflow tools — contacts, companies, deals, tickets, tasks, notes, sequences, and more. Most HubSpot chat integrations offer 3–8 tools. Velaro gives your team and your bots full CRM read/write access without leaving the conversation.
          </div>
        </div>
      </div>

      <div className="text-sm text-zinc-800 space-y-3">
        <p>
          Connect HubSpot CRM so your support agents can instantly look up contact history, deal status, and account details during live conversations — without switching tabs.
        </p>
        <p>
          When a chat ends, Velaro automatically pushes the full conversation transcript to HubSpot as a Note on the matched contact. Every interaction is logged, searchable, and available to your sales and support teams.
        </p>
        <p>
          You can also use HubSpot data in workflow nodes — query contacts, check lifecycle stage, or create new contacts automatically when a visitor provides their email.
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {([
          { title: "Contact Lookup", desc: "Search HubSpot contacts by email or name directly from the agent sidebar during live chats.", icon: "Search" },
          { title: "Transcript Push", desc: "Full chat transcripts are automatically pushed to HubSpot as Notes on the matched contact after each conversation.", icon: "Edit" },
          { title: "AI Workflow Tools", desc: "29 tools let your bot create deals, update pipeline, enroll sequences, create tickets, and log tasks mid-conversation.", icon: "Bot" },
          {
            title: "Velaro Chat History Card",
            desc: "Open any HubSpot contact's Catch-up tab and see a live Velaro panel: every conversation's status, wait time, real CSAT, AI sentiment, topic, and AI summary — no separate app to switch to.",
            icon: "FileText",
            link: "https://ecosystem.hubspot.com/marketplace/listing/velaro-live-chat",
            linkLabel: "View in HubSpot Marketplace"
          },
          { title: "Timeline Events", desc: "Every chat automatically logged in your HubSpot contact activity feed. No manual logging needed.", icon: "Zap" }
        ] as Array<{ title: string; desc: string; icon: string; link?: string; linkLabel?: string }>).map((f) => (
          <div key={f.title} className="rounded-lg border border-zinc-200 p-4">
            <div className="text-zinc-600 mb-2"><IconByName name={f.icon} className="w-6 h-6" /></div>
            <div className="font-medium text-zinc-800 text-sm mb-1">{f.title}</div>
            <div className="text-xs text-zinc-500">{f.desc}</div>
            {f.link && (
              <a
                href={f.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-[var(--color-primary)] font-medium mt-2 inline-block hover:underline"
              >
                {f.linkLabel} →
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function HubSpotBackToIntegrationLanding() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-zinc-600" onClick={() => navigate("/integrations")}>
      <IconArrowLeft className="h-6 w-6" />
      Back
    </div>
  );
}

export function HubSpotBackToHubSpotOverview() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-zinc-600" onClick={() => navigate("/integrations/hubspot/overview")}>
      <IconArrowLeft className="h-6 w-6" />
      Back to HubSpot
    </div>
  );
}
